<template>
  <teleport to="#destination">
    <vue-final-modal v-bind="$attrs" :classes="'modal-container pop_wrap ' + containerClass" :content-class="'modal-content pop_content ' + contentClass" overlay-class="dimm">
      <slot></slot>
    </vue-final-modal>
  </teleport>
</template>

<script>
export default {
  name: 'VDynamicModal',
  inheritAttrs: false,
  props: {
    containerClass: String,
    contentClass: String
  }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* ::v-deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
} 
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}  */
</style>

<style scoped>
/* .dark-mode div::v-deep(.modal-content) {
  border-color: #2d3748;
  background-color: #1a202c;
} */
</style>